import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import DateAndTimePicker from "../components/DateAndTimePicker";
import { useDataLayerValue } from "../DataLayer/DataLayer";
import { getMyZone, getTimeData } from "./getTimeDate";
import { getAllLocations } from "../utils/ApiCalls/Locations";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "10px",
  border: "none",
  boxShadow: 24,
  p: 4,
};

function isHTML(str) {
  var doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
}

const ValidDateUI = ({ record, time, handleUpdate, locationOption,regionalActive }) => {

  const [valid_from, setValidFrom] = useState(record?.valid_from);
  const [valid_to, setValidTo] = useState(record?.valid_to);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [, dispatch] = useDataLayerValue();
  useEffect(() => {
    if (record) {
      if (time && locationOption?.length > 0) {
        const locObj = locationOption.find(item => item.id == record.location_id);
        const tz = locObj?.timezone || "Asia/Kuala_Lumpur";
        setValidFrom(record?.valid_from ? moment.utc(record.valid_from).tz(tz).format("YYYY-MM-DDTHH:mm:ss") : record?.valid_from);
        setValidTo(record?.valid_to ? moment.utc(record.valid_to).tz(tz).format("YYYY-MM-DDTHH:mm:ss") : record?.valid_to);
      } else {
        setValidFrom(record?.valid_from);
        setValidTo(record?.valid_to);
      }
    }
  }, [record, regionalActive, locationOption]);

  return (
    <>

      <div style={{ display: "flex" }}>
        <p style={{ padding: "8px" }}>{(() => {
          const tz = (time && locationOption?.length > 0)
            ? (locationOption.find(item => item.id == record.location_id)?.timezone || "Asia/Kuala_Lumpur")
            : null;
          const fmt = (d) => tz ? moment.utc(d).tz(tz).format("DD/MM/YYYY") : moment(d).format("DD/MM/YYYY");
          return `${fmt(record.valid_from)} - ${fmt(record.valid_to)}`;
        })()}</p>
        <div
          className="btn"
          onClick={() => {
            handleOpen();

          }}
        >
          <i className="ri-edit-2-line" data-toggle="tooltip" title="Edit"></i>
        </div>
      </div>

      <Modal
        open={open}
        onClose={(e) => {
          handleClose();

        }}
        sx={{ border: "none" }}
      >
        <Box sx={style}>

          {isHTML() ? (
            <h4
              style={{ fontWeight: "bold" }}
              dangerouslySetInnerHTML={{ __html: record.english_title }}
            />
          ) : (
            <h4 style={{ fontWeight: "bold" }}>{record.title}</h4>
          )}

          <form className="input_form">
            <div className="row">
              <div className="col-lg-12 col-md-6 col-sm-6 col-6">
                <div className="fieldrow">
                  <label className="f_label"> Valid From</label>


                  <DateAndTimePicker
                    required
                    value={valid_from}
                    setValue={(e) => {
                      const val = e ? (e?.format ? e.format("YYYY-MM-DDTHH:mm:ss") : e) : "";
                      setValidFrom(val);
                      setValidTo("");
                    }}
                    max={
                      record.to_date &&
                      moment(record.to_date).format("YYYY-MM-DD")
                    }
                    min={moment(new Date()).format("YYYY-MM-DD")}
                    type="date"
                    className="f_input"
                  />
                  {/* {time && locationOption?.length > 0 && <p style={{ marginTop: "5px" }}><b>{moment(getTimeData(valid_from, locationOption.find(item => item.id == record.location_id)?.timezone))?.format("DD/MM/YYYY hh:mm a")}</b></p>
                  } */}
                </div>
              </div>
              <div className="col-lg-12 col-md-6 col-sm-6 col-6">
                <div className="fieldrow">
                  <label className="f_label">Valid To</label>

                  <DateAndTimePicker
                    required
                    type="date"
                    className="f_input"
                    value={valid_to}
                    setValue={(e) => {
                      const val = e ? (e?.format ? e.format("YYYY-MM-DDTHH:mm:ss") : e) : "";
                      setValidTo(val);
                    }}
                    max={
                      record.to_date &&
                      moment(record.to_date).format("YYYY-MM-DD")
                    }
                    min={moment(valid_from).format("YYYY-MM-DD")}
                  />
                  {/* {time && locationOption?.length > 0 && <p style={{ marginTop: "5px" }}><b>{moment(getTimeData(valid_to, locationOption.find(item => item.id == record.location_id)?.timezone))?.format("DD/MM/YYYY hh:mm a")}</b></p>
                  } */}
                  </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "right",
                marginTop: "10%",
              }}
            >
              <Button
                variant="contained"
                onClick={(e) => {
                  handleClose();
                  try {
                    if (!moment(valid_from).isValid()) {
                      throw new Error("Please provide valid_from date");
                    }
                    if (!moment(valid_to).isValid()) {
                      throw new Error("Please provide valid_to date");
                    }

                    handleUpdate(
                      record.id,
                      {
                        valid_from: time ? moment.tz(valid_from, locationOption.find(item => item.id == record.location_id)?.timezone || "Asia/Kuala_Lumpur").utc().format("YYYY-MM-DDTHH:mm:ss") : new Date(valid_from),
                        valid_to: time ? moment.tz(valid_to, locationOption.find(item => item.id == record.location_id)?.timezone || "Asia/Kuala_Lumpur").utc().format("YYYY-MM-DDTHH:mm:ss") : new Date(valid_to),
                        isDateEdit: true,
                      },
                      record.title,
                      record.location_id
                    );

                  } catch (error) {
                    dispatch({
                      type: "SET_LOADING",
                      loading: false,
                    });

                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: error.message,
                    });
                  }
                }}
              >
                Save
              </Button>
            </div>
          </form>
          {time && locationOption.length > 0 && <div>
            <p style={{ marginTop: "10px", fontSize: "14px" }}>{"* Dates will saved in " + locationOption.find(item => item.id == record.location_id)?.location_name + " timezone  " + locationOption.find(item => item.id == record.location_id)?.timezone + " your timezone is " + getMyZone()}</p>
          </div>}
        </Box>
      </Modal>
      {/* </form> */}
    </>
  );
};

export default ValidDateUI;
